import { useCallback, useMemo } from 'react';

const SEARCH_HISTORY_KEY = 'user_global_search_history';

export const useGlobalSearchHistoryTracking = (limit: number = 10) => {
  const getHistory = useCallback((): string[] => {
    const raw = localStorage.getItem(SEARCH_HISTORY_KEY);
    return raw ? JSON.parse(raw) : [];
  }, []);

  const trackSearchTerm = useCallback(
    (term: string) => {
      if (!term.trim()) return;

      const current = getHistory().filter(
        (t) => t.toLowerCase() !== term.toLowerCase()
      );
      const updated = [term, ...current].slice(0, limit);
      localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(updated));
    },
    [getHistory, limit]
  );

  const searchHistory = useMemo(() => getHistory(), [getHistory]);

  return {
    trackSearchTerm,
    searchHistory,
  };
};
